import { apiDelete, apiGet } from '@/services/api-client';

export type AccountSessionDto = {
  id: number;
  jti: string;
  is_current: boolean;
  os: string;
  browser: string;
  ip: string | null;
  location: string;
  user_agent?: string | null;
  last_used_at: string | null;
};

export async function fetchAccountSessions(): Promise<AccountSessionDto[]> {
  const res = await apiGet<{ data: AccountSessionDto[] }>('/admin/account/sessions', true);
  return res.data ?? [];
}

export async function revokeOtherAccountSessions(): Promise<AccountSessionDto[]> {
  const res = await apiDelete<{ data: AccountSessionDto[]; revoked?: number }>(
    '/admin/account/sessions/others',
    true
  );
  return res.data ?? [];
}
